export type GetDocument360RedirectUrlApiArg = {redirectTo: string};
export type GetDocument360RedirectUrlApiRes = {redirectUrl: string};
